import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconHammer: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"hammer, craft, build"} maskId="square-filled-radius-0-stroke-1-IconHammer"><path d="M0.5 11.5L10 2H15L17 4L5 16L0.5 11.5Z" fill="currentColor"/><path fillRule="evenodd" clipRule="evenodd" d="M18.5 22L9.5 13L13 9.5L22 18.5L18.5 22Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconHammer;
